<template>
  <div class="minwidth w100 mw100" style="position: relative;background-color: #0E2038;">
    <tabbar></tabbar>

    <!-- <carousel2></carousel2> -->

    <div style="width: 80%;margin: 0 auto;display: flex;justify-content: space-between;align-items: flex-end;"
      class="mw100">
      <div style="width: 60%;">
        <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;">关于我们</div>
        <div style="font-size: 0.9rem;color: #999999;">ABOUT US</div>
        <div
          style="color: #fff;font-size: 1.2rem;text-indent: 2em;line-height: 2rem;text-align: justify;margin-top: 2rem;">
          上海柿意科技有限公司成立于2021年，是一家以数据智能驱动的创新型科技企业，专注于移动互联网运营服务。秉承“以客户为中心”的核心理念，公司深度聚焦企业用户行业，通过精准洞察行业趋势与需求，致力于解决企业用户在公众运营与全客运营领域的关键痛点，提供全链路战略规划与服务解决方案。
          柿意科技长期与互联网媒体平台及知名应用保持深度合作，已成功赋能30+省市级企业用户客户，助力200+通信产品实现卓越运营与推广，赢得了行业的高度认可。
        </div>
        <div style="color: #fff;font-size: 1.2rem;text-indent: 2em;line-height: 2rem;text-align: justify;">
          依托对接投流平台（巨量、广点通等）的20亿连接终端、12.6亿活跃用户及每年新增的1,500万入网用户数据资源，柿意科技可实时更新12万个标签特征，支撑精准人群画像建模需求。公司以专业化、数字化与精细化的服务能力，致力于成为互联网通信业务发展的标杆企业，为客户创造持续价值，推动行业迈向更高效、更智能的未来。
        </div>
        <div style="display: flex;justify-content: space-around;align-items: center;width: 100%;margin-top: 1rem;">
          <img style="width: 25%;" :src="require('../../public/img/partner/textBtm1.png')" alt="">
          <img style="width: 25%;" :src="require('../../public/img/partner/textBtm2.png')" alt="">
          <img style="width: 25%;" :src="require('../../public/img/partner/textBtm3.png')" alt="">
          <img style="width: 25%;" :src="require('../../public/img/partner/textBtm4.png')" alt="">
        </div>
      </div>
      <div style="width: 35%;">
        <img style="width: 100%;" :src="require('../../public/img/partner/about.png')" alt="">
      </div>
    </div>

    <div>
      <div style="font-size: 2rem;font-weight: bolder;text-align: center;color: #fff;margin-top: 3rem;">团队介绍</div>
      <div style="font-size: 1rem;text-align: center;color: #999999;">TEAM INTRODUCTION</div>
      <div
        style="display: flex;justify-content: space-between;align-items: center;width: 90%;margin: 0 auto;margin-top: 1rem;margin-bottom: 3rem;">
        <div style="width: 35%;text-align: center;">
          <img style="width: 90%;border-radius: 1rem;" :src="require('../../public/img/partner/work.png')" alt="">
        </div>
        <div
          style="width: 65%;text-align: justify;color: #fff;font-size: 1.2rem;line-height: 2.1rem;text-align: justify;text-indent: 2em;">
          上海柿意科技有限公司总部位于上海，并在全国范围内与头部互联网媒体及知名应用建立了深度合作关系。公司团队聚集了国内优秀的互联网产品、研发等专业人才，积累了丰富的企业用户行业服务经验和通信产品推广运营经验。团队凭借对行业痛点的敏锐洞察力，不断探索行业数字化转型的新路径，助力企业用户实现更高效的商业增长。
          目前，团队成员呈现年轻化、高学历、成长性强等特点，其中90%以上拥有本科及以上学历，核心成员大多毕业于211/985重点院校，研究生比例超过6%。此外，公司在人工智能、大数据处理等高新领域组建了技术攻坚团队，为核心技术的研发和创新提供了强有力的支撑。这支团队为柿意科技在移动互联网运营领域保持技术领先地位奠定了坚实基础。
        </div>
      </div>
    </div>

    <!-- <div>
      <div style="font-size: 2rem;font-weight: bolder;text-align: center;color: #fff;margin-top: 3rem;">公司历程</div>
      <div style="font-size: 1rem;text-align: center;color: #999999;">COMPANY HISTORY</div>
      <div style="width: 50%;margin: 0 auto;margin-top: 2rem;">
        <el-timeline>
          <el-timeline-item timestamp="2021年" placement="top">
            <el-card>
              <h3>上海柿意科技有限公司成立</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2022年3月" placement="top">
            <el-card>
              <h3>人工智能SaaS服务平台</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2022年5月" placement="top">
            <el-card>
              <h3>中国联通渠道代理商</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2022年8月" placement="top">
            <el-card>
              <h3>上线移动、联通、电信手机流量、套餐、权益业务等增值业务覆盖全国</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2023年2月" placement="top">
            <el-card>
              <h3>与全国企业用户及30+省公司达成业务合作</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2024年3月" placement="top">
            <el-card>
              <h3>整合多方权益供应商，上线生活周边</h3>
          </el-timeline-item>
          <el-timeline-item timestamp="2024年3月" placement="top">
            <el-card>
              <h3>与新疆联通合作上线在线小游戏</h3>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2024年7月" placement="top">
            <el-card>
              <h3>与字节跳动、支付宝、微信、整合企业用户资源打造新增值业务IP</h3>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div> -->

    <!-- <div style="margin-top: 3rem;padding-bottom: 2rem;">
      <div style="font-size: 1.5rem;text-align: center;color: #fff;padding-top: 2rem;">
        柿意科技的业务已覆盖全国范围，与企业用户及其多家基地公司建立了深度合作关系
      </div>
      <div style="font-size: 1rem;text-align: center;color: #666;margin-top: 1rem;">
        企业用户的广泛协作，柿意科技持续拓展业务版图，为企业用户的数字化转型和业务增长提供全方位支持，推动行业高效发展。
      </div>
      <div
        style="display: flex;justify-content: space-around;align-items: center;width: 20%;margin: 0 auto;margin-top: 2rem;font-size: 1.5rem;color: #666;border-bottom: solid 1px #666;height: 6rem;">
        <div style="height: 6rem;line-height: 6rem;flex: 0.9;text-align: center;cursor: pointer;"
          :style="typeIndex == 0 ? 'border-bottom: solid 1px #06D1ED;color: #06D1ED;':''" @click="typeIndex = 0">合作伙伴
        </div>
        <div style="height: 6rem;line-height: 6rem;flex: 0.9;text-align: center;cursor: pointer;"
          :style="typeIndex == 1 ? 'border-bottom: solid 1px #06D1ED;color: #06D1ED;':''" @click="typeIndex = 1">权益品牌
        </div>
      </div>
      <div v-if="typeIndex == 0" style="display: flex;flex-wrap: wrap;width: 80%;margin: 0 auto;align-items: center;margin-top: 1rem;">
        <div style="width: 100%;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/partner.png`)" alt="">
        </div>
      </div>
      <div v-if="typeIndex == 1" style="display: flex;flex-wrap: wrap;width: 80%;margin: 0 auto;align-items: center;margin-top: 1rem;">
        <div style="width: 100%;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/rights.png`)" alt="">
        </div>
      </div>
    </div> -->

    <!-- <div style="width: 80%;margin: 0 auto;margin-top: 5rem;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;text-align: center;">企业文化</div>
      <div style="font-size: 1rem;color: #999999;text-align: center;">CORPORATE CULTURE</div>
    </div>
    <div
      style="display: flex;width: 80%;margin: 0 auto;justify-content: space-around;align-items: stretch;padding-bottom: 3rem;margin-top: 2rem;">
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业愿景
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company1_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;margin-top: 2.5rem;">
          创新驱动，客户至上，<br>
          团队协作，共同成长。<br>
        </div>
      </div>
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业愿景
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company2_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;margin-top: 2.5rem;">
          成为企业用户行业数字化转型的引领者，<br>
          打造移动互联网信息服务的领先品牌。
        </div>
      </div>
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业文化
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company3_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;padding-bottom: 1rem;margin-top: 1rem;">
          客户第一：关注需求，创造价值。<br>
          创新为本：技术领先，持续突破。<br>
          协作共赢：团队合作，共创未来。<br>
          诚信专业：用实力赢得信任。<br>
        </div>
      </div>
    </div> -->

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        typeIndex: 0
      };
    },
  };
</script>

<style scoped>
  .outbody {
    background-color: #1D1D1D;
    min-height: 1000px;
    margin: 0;
    font-family: 'Droid Sans', sans-serif;

    &:before {
      content: '';
      position: fixed;
      top: 0px;
      left: 50%;
      bottom: 0px;
      transform: translateX(-50%);
      width: 4px;
      background-color: #fff;
    }

    .entries {
      width: calc(100% - 80px);
      max-width: 800px;
      margin: auto;
      position: relative;
      left: -5px;

      .entry {
        width: calc(50% - 80px);
        float: left;
        padding: 20px;
        clear: both;
        text-align: right;

        &:not(:first-child) {
          margin-top: -60px;
        }

        .title {
          font-size: 32px;
          margin-bottom: 12px;
          position: relative;
          color: #fff;

          &:before {
            content: '';
            position: absolute;
            width: 8px;
            height: 8px;
            border: 4px solid #ffffff;
            background-color: #1D1D1D;
            border-radius: 100%;
            top: 50%;
            transform: translateY(-50%);
            right: -73px;
            z-index: 1000;
          }

          &.big:before {
            width: 24px;
            height: 24px;
            transform: translate(8px, -50%);
          }
        }

        .body {
          color: #aaa;

          p {
            line-height: 1.4em;
          }
        }

        &:nth-child(2n) {
          text-align: left;
          float: right;

          .title {
            &:before {
              left: -63px;
            }

            &.big:before {
              transform: translate(-8px, -50%);
            }
          }
        }
      }
    }
  }


  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .w80 {
    width: 80%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .margintop50 {
    margin-top: 50px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .textcent {
    text-align: center;
  }

  .fontsize50 {
    font-size: 50px;
  }

  .margincent {
    margin: 0 auto;
  }

  .positionrel {
    position: relative;

    height: 440px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);

    width: 1920px;
  }

  @media screen and (max-width: 750px) {
    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .flexnone {
      display: block;
    }

    .fontsize30 {
      font-size: 30px;
    }

    .positionrel {
      position: relative;

      height: 179px;
      overflow: hidden;
    }

    .positionabs {
      position: absolute;
      left: 50%;
      transform: translate(-50%);

      width: 780px;
    }
  }
</style>